import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import { IFormDetails } from '../dashboardConfiguration/types';
import { DynamicDashboardService } from './service';

export interface ICardDetails {
  count: number;
  progressStartCount: number;
  progressEndCount: number;
  status: string;
  statusCount?: number;
}

export interface ICard2Details {
  count: number;
  description?: string;
}

export interface IChartDetails {}

export interface ITableDetails {}

export interface IPivotDetails {}

export interface IComponentDetails {}

interface IDynamicDashboard {
  levelId: string;
  name: string;
  type: string;
  flexBasis: string;
  masterId: string | null;
  prod?: {
    needChart: boolean | null;
  };
  icon?: string;
  permission: number;
  data:
    | ICardDetails
    | ICard2Details
    | IChartDetails
    | ITableDetails
    | IFormDetails
    | IPivotDetails
    | IComponentDetails[];
}

class DynamicDashboard {
  dashboard: {
    [key: string]: {
      data: IDynamicDashboard[];
      selectedId: string;
    };
  } = {};
  isDashboardLoading: boolean = false;
  staticSelectedCard: string = '';
  assetChangedByHOD: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  getLevelDetailsBasedOnParent = async (levelId: string) => {
    try {
      let result = await DynamicDashboardService.getDetailsbasedOnParent({
        levelId,
      });
      if (result.data) {
        return result.data;
      }
    } catch (error) {
      toast.error('Pls Try Again !');
      console.log(error);
      return error;
    }
  };

  getLevelDetails = async () => {
    try {
      let result = await DynamicDashboardService.levelDetailsGET();
      if (result.data) {
        return result.data;
      }
    } catch (error) {
      toast.error('Pls Try Again !');
      console.log(error);
      return error;
    }
  };

  assignUserMaster = async (assetIds: string[], userId: string) => {
    try {
      assetIds?.forEach(async (assetId) => {
        const res = await DynamicDashboardService.assignUserMaster(
          assetId,
          userId,
        );
        runInAction(() => {
          if (res !== null && !res?.data?.includes('successfully')) {
            toast.error('Something went wrong. Please try again.');
          }
        });
      });
    } catch (error) {
      toast.error(
        'Failed to assign user. Data may not be visible to you. Contact Admin.',
      );
      console.log('API Failed: ', error);
    }
  };
}

export default DynamicDashboard;
